import { useSetting } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { FE_INVALIDATE_PRODUCT_REVIEW_CONDUCTOR_CAMPAIGN_DELAY_MS_250828 } from "@faire/retailer-settings/FE_INVALIDATE_PRODUCT_REVIEW_CONDUCTOR_CAMPAIGN_DELAY_MS_250828";

export const useSettingInvalidateProductReviewConductorCampaignDelayMs =
  (): number =>
    useSetting(FE_INVALIDATE_PRODUCT_REVIEW_CONDUCTOR_CAMPAIGN_DELAY_MS_250828);
